import { Step } from 'components/NewRelease/constants';

export const getReadyStatus = (id: Step, search: string): boolean => {
  const queryParams = new URLSearchParams(location.search);
  const currentStep = queryParams.get("step");

  switch (id) {
    case Step.Type: {
      return currentStep !== Step.Type;
    }
    case Step.UploadImage: {
      return currentStep !== Step.Type && currentStep !== Step.UploadImage;
    }
    case Step.ReleaseInfo: {
      return currentStep !== Step.Type && currentStep !== Step.UploadImage && currentStep !== Step.ReleaseInfo;
    }
    case Step.TrackUpload: {
      return currentStep === Step.Publish || currentStep === Step.Platform;
    }
    case Step.TrackInfo: {
      return currentStep === Step.Publish || currentStep === Step.Platform;
    }
    case Step.Publish: {
      return currentStep === Step.Platform;
    }
    case Step.Platform:
    default: {
      return false;
    }
  }
};
